// extracted by mini-css-extract-plugin
export default {"forgotContainer":"AuthButtons_forgotContainer__NG45H","forgotButton":"AuthButtons_forgotButton__aNEdp","loginButton":"AuthButtons_loginButton__XmfbF"};